<template>
  <div>
    <div class="container">
      <!-- main controls -->
      <div class="row marginNormalTop marginNormalBottom">
        <div class="two columns">
          <button
            v-if="auctionStatus !== 'concluded'"
            class="bidButton u-full-width warningButton"
            type="submit"
            @click.prevent="endAuction"
          >
            End Auction
          </button>
          <button
            v-if="auctionStatus === 'concluded'"
            class="bidButton u-full-width backgroundColorDefault"
            type="submit"
            @click.prevent="startAuction"
          >
            Start Auction
          </button>
        </div>
        <div class="two columns">
          <button
            v-if="auctionStatus !== 'paused'"
            class="bidButton u-full-width warningButton"
            type="submit"
            @click.prevent="pauseAuction"
          >
            Pause Auction
          </button>
          <button
            v-if="auctionStatus === 'paused'"
            class="bidButton u-full-width backgroundColorDefault"
            type="submit"
            @click.prevent="resumeAuction"
          >
            Resume Auction
          </button>
        </div>
        <div class="two columns">
          <input
            id="inputAuctionId"
            v-model="setAuctionId"
            type="text"
            placeholder="Auction"
          >
        </div>
        <div class="one columns">
          <input
            id="inputLiveAuctioneersUrl"
            v-model="liveAuctioneersUrl"
            type="text"
            placeholder="LA"
          >
        </div>
        <div class="two columns">
          <input
            id="inputLotNumber"
            v-model="setLotNumber"
            type="text"
            placeholder="Lot"
          >
        </div>
        <div class="two columns">
          <button
            class="bidButton u-full-width understatedButton"
            type="submit"
            @click.prevent="setLot"
          >
            Go to Lot
          </button>
        </div>
      </div>

      <div
        v-if="auctionStatus === 'paused'"
        class="row marginLargeTop marginLargeBottom"
      >
        <div class="fontLarge paddingSmallTop flexBoxCentered colorWhite backgroundColorError">
          <div class="marginSmallBottom">
            Auction is paused
          </div>
        </div>
      </div>

      <div class="row">
        <div class="twelve columns">
          {{ virtualAuctioneerStatus.message }}
          &nbsp;
        </div>
      </div>

      <!-- the different platforms -->
      <div class="row">
        <!-- joeflex -->
        <div class="six columns">
          <div class="container">
            <!-- platform title -->
            <div class="twelve columns minorTitle">
              LL
            </div>

            <!-- lot number and lead -->
            <div class="twelve columns marginNormalBottom">
              <span class="fontBold">Lot {{ item.display_lotnumber }}</span> &middot; {{ item.lead }}
            </div>

            <!-- the image and the bidding status -->
            <div class="row">
              <div class="twelve columns marginNormalBottom">
                <!-- lead image -->
                <div class="six columns">
                  <img
                    class="leadImage"
                    :src="item.lead_image"
                    alt=""
                  >
                </div>

                <!-- bidding status -->
                <div class="six columns textCenter">
                  <!-- asking price -->
                  <div v-if="itemBiddingStatus.is_bidding_open && askingAmount > 0">
                    Current Ask<br>
                    <span
                      v-if="itemBiddingStatus.is_bidding_open && askingAmount > 0"
                      class="fontBold"
                    >
                      ${{ formatCurrency(askingAmount) }}
                    </span>
                    <span v-else-if="askingAmount > 0">
                      -
                    </span>
                    <input
                      id="inputBidAmount"
                      ref="inputBidAmount"
                      v-model.number="askingAmount"
                      type="number"
                      class="hidden"
                      placeholder=""
                    >
                  </div>

                  <!-- sold status -->
                  <div v-else-if="askingAmount > 0">
                    <span v-if="itemBiddingStatus.has_passed">
                      This lot has passed
                    </span>
                    <span v-else-if="itemBiddingStatus.has_sold">
                      This lot has sold
                    </span>
                    <span v-else-if="!itemBiddingStatus.has_sold">
                      Bidding has closed
                    </span>
                  </div>

                  <!-- current high bidder info -->
                  <div class="minorTitle colorGrey">
                    <div v-if="displayBidCard.length > 0 && itemBiddingStatus.current_high_bid_amount > 0">
                      <div
                        v-if="!itemBiddingStatus.has_sold"
                        class="paddingSmallBottom"
                      >
                        Current High Bidder
                      </div>
                      <div
                        v-else-if="itemBiddingStatus.has_sold"
                        class="paddingSmallBottom"
                      >
                        Winning Bidder
                      </div>
                      <div class="fontLarge">
                        ${{ formatCurrency(itemBiddingStatus.current_high_bid_amount) }}&nbsp;&nbsp;&middot;&nbsp;&nbsp;{{ displayBidCard }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- liveauctioneers -->
        <div class="six columns">
          <div class="container">
            <div class="twelve columns">
              {{ virtualAuctioneerStatus.la_console_status }}
            </div>

            <!-- platform title -->
            <div class="twelve columns minorTitle">
              LA
            </div>

            <!-- lot number and lead -->
            <div class="row marginNormalBottom">
              <div class="twelve columns">
                <span class="fontBold">Lot {{ item.display_lotnumber }}</span> &middot; {{ item.lead }}
              </div>
            </div>

            <!-- the image and the bidding status -->
            <div class="row">
              <div class="twelve columns marginNormalBottom">
                <!-- lead image -->
                <div class="six columns">
                  <img
                    class="leadImage"
                    :src="item.lead_image"
                    alt=""
                  >
                </div>

                <!-- bidding status -->
                <div class="six columns textCenter">
                  <!-- asking price -->
                  <div v-if="itemBiddingStatus.is_bidding_open && askingAmount > 0">
                    Current Ask<br>
                    <span
                      v-if="itemBiddingStatus.is_bidding_open && askingAmount > 0"
                      class="fontBold"
                    >
                      ${{ formatCurrency(askingAmount) }}
                    </span>
                    <span v-else-if="askingAmount > 0">
                      -
                    </span>
                    <input
                      id="inputBidAmount"
                      ref="inputBidAmount"
                      v-model.number="askingAmount"
                      type="number"
                      class="hidden"
                      placeholder=""
                    >
                  </div>

                  <!-- sold status -->
                  <div v-else-if="askingAmount > 0">
                    <span v-if="itemBiddingStatus.has_passed">
                      This lot has passed
                    </span>
                    <span v-else-if="itemBiddingStatus.has_sold">
                      This lot has sold
                    </span>
                    <span v-else-if="!itemBiddingStatus.has_sold">
                      Bidding has closed
                    </span>
                  </div>

                  <!-- current high bidder info -->
                  <div class="minorTitle colorGrey">
                    <div v-if="displayBidCard.length > 0 && itemBiddingStatus.current_high_bid_amount > 0">
                      <div
                        v-if="!itemBiddingStatus.has_sold"
                        class="paddingSmallBottom"
                      >
                        Current High Bidder
                      </div>
                      <div
                        v-else-if="itemBiddingStatus.has_sold"
                        class="paddingSmallBottom"
                      >
                        Winning Bidder
                      </div>
                      <div class="fontLarge">
                        ${{ formatCurrency(itemBiddingStatus.current_high_bid_amount) }}&nbsp;&nbsp;&middot;&nbsp;&nbsp;{{ displayBidCard }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- the console buttons and messages -->
      <div class="row">
        <!-- joeflex -->
        <div class="six columns">
          <div class="container">
            <!-- Custom Bid input for Floor, Phone, and House buttons -->
            <div class="customBidContainer">
              <p>Custom Bid:</p>
              <input
                v-model="customBidAmount"
                :placeholder="askingAmount"
                type="number"
              >
            </div>

            <!-- the bid buttons -->
            <div class="row marginXSmallBottom">
              <div class="four columns">
                <button
                  :disabled="itemBiddingStatus.pending_bid"
                  :class="{ disabledButton: itemBiddingStatus.pending_bid, backgroundColorDefault: !itemBiddingStatus.pending_bid }"
                  class="bidButton u-full-width"
                  type="submit"
                  @click.prevent="floorBid"
                >
                  Floor
                </button>
              </div>
              <div class="four columns">
                <button
                  :disabled="itemBiddingStatus.pending_bid"
                  :class="{ disabledButton: itemBiddingStatus.pending_bid, backgroundColorDefault: !itemBiddingStatus.pending_bid }"
                  class="bidButton u-full-width"
                  type="submit"
                  @click.prevent="phoneBid"
                >
                  Phone
                </button>
              </div>
              <div class="four columns">
                <button
                  :disabled="itemBiddingStatus.pending_bid"
                  :class="{ disabledButton: itemBiddingStatus.pending_bid, backgroundColorDefault: !itemBiddingStatus.pending_bid }"
                  class="bidButton u-full-width"
                  type="submit"
                  @click.prevent="houseBid"
                >
                  House
                </button>
              </div>
            </div>

            <div class="row marginNormalBottom">
              <!-- <div class="four columns">
                <button v-bind:class="{ disabledButton: itemBiddingStatus.pending_bid, backgroundColorDefault: !itemBiddingStatus.pending_bid }" class="bidButton u-full-width" type="submit" @click.prevent="laBid">LA</button>
              </div> -->
              <div class="twelve columns">
                <button
                  :class="{ disabledButton: ( itemBiddingStatus.pending_bid || Podium.upNow.amount === null) , backgroundColorSuccess: (Podium.upNow.amount !== null && !itemBiddingStatus.pending_bid)}"
                  class="bidButton u-full-width"
                  type="submit"
                  @click.prevent="recognizeBid"
                >
                  Internet<br><span v-if="Podium.upNow.amount !== null">${{ Podium.upNow.amount }}</span>&nbsp;
                </button>
              </div>
            </div>

            <!-- the messaging component -->
            <div class="row marginNormalBottom">
              <div class="twelve columns">
                <div class="row marginXSmallBottom">
                  <div class="eight columns">
                    <div class="twelve columns">
                      <input
                        id="customMessage"
                        v-model="customMessage"
                        type="text"
                        placeholder="Custom Message"
                      >
                    </div>
                  </div>
                  <div class="four columns">
                    <button
                      class="bidButton u-full-width understatedButton"
                      type="submit"
                      @click.prevent="sendPodiumMessage"
                    >
                      Send
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="four columns">
                    <button
                      class="bidButton u-full-width understatedButton fontSmall"
                      type="submit"
                      @click.prevent="sendSellingNowMessage"
                    >
                      "Please bid quickly!"
                    </button>
                  </div>
                  <div class="four columns">
                    <button
                      class="bidButton u-full-width understatedButton fontSmall"
                      type="submit"
                      @click.prevent="sendFairWarningMessage"
                    >
                      "Fair Warning!"
                    </button>
                  </div>
                  <div class="four columns">
                    <button
                      class="bidButton u-full-width understatedButton fontSmall"
                      type="submit"
                      @click.prevent="sendFinalCallMessage"
                    >
                      "Final Call!"
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- the selling and advancing buttons -->
            <div class="row marginLargeBottom">
              <div class="twelve columns">
                <div class="row marginXSmallBottom">
                  <div class="four columns">
                    <span v-if="itemBiddingStatus.is_bidding_open">
                      <button
                        class="bidButton u-full-width understatedButton"
                        type="submit"
                        @click.prevent="closeBidding"
                      >Close</button>
                    </span>
                    <span v-else>
                      <button
                        class="bidButton u-full-width understatedButton"
                        type="submit"
                        @click.prevent="openBidding"
                      >Open</button>
                    </span>
                  </div>
                  <div class="four columns">
                    <button
                      class="bidButton u-full-width understatedButton"
                      type="submit"
                      @click.prevent="sellLot"
                    >
                      Sell
                    </button>
                  </div>
                  <div class="four columns">
                    <button
                      class="bidButton u-full-width understatedButton"
                      type="submit"
                      @click.prevent="nextLot"
                    >
                      Next
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="four columns">
                    <button class="bidButton u-full-width disabledButton">
                      &lt;empty&gt;
                    </button>
                  </div>
                  <div class="four columns">
                    <button
                      class="bidButton u-full-width understatedButton"
                      :class="{ disabledButton: itemBiddingStatus.is_bidding_open }"
                      type="submit"
                      @click.prevent="passLot"
                    >
                      Pass
                    </button>
                  </div>
                  <div class="four columns">
                    <button class="bidButton u-full-width disabledButton">
                      &lt;empty&gt;
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="six columns">
          <div class="container">
            <div class="scrollableMessageBox">
              <div
                v-if="itemBiddingStatus.pending_bid"
                class="row marginXSmallBottom bidLoadingContainer absoluteCenter"
              >
                <div class="loading" />
              </div>
              <div v-if="!itemBiddingStatus.pending_bid">
                <div
                  v-for="item in messageList"
                  :key="item.payload && item.payload.bid_id ? item.payload.bid_id : Math.random()"
                  :class="{ flagColorSuccess: item.result === 'success', flagColorError: item.result === 'failure', paddingSmallLeft: true, marginSmallBottom: true, scrollableMessage: true }"
                >
                  {{ item.message }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BiddingMessages from '@/components/BiddingMessages'
export default {
  name: 'AuctioneerScreen',
  components: {
    BiddingMessages
  },
  props: [
    'item_id'
  ],
  data () {
    return {
      setAuctionId: '',
      setLotNumber: '',
      liveAuctioneersUrl: '',
      customMessage: '',
      askingAmount: 0,
      customBidAmount: '',
      messageList: []
    }
  },

  computed: {
    apiResponse: function () {
      return this.$store.getters.apiResponse
    },

    virtualAuctioneerStatus: function () {
      return this.$store.getters.virtualAuctioneerStatus
    },

    currentLiveInventoryId: function () {
      return this.$store.getters.currentLiveInventoryId
    },

    item: function () {
      if (this.$store.getters.item(this.currentLiveInventoryId) === null) {
        return {
          inventory_id: 0,
          lead_image: '',
          display_lotnumber: '',
          lead: ''
        }
      }
      return this.$store.getters.item(this.currentLiveInventoryId)
    },

    itemBiddingStatus: function () {
      return this.$store.getters.itemBiddingStatus(this.currentLiveInventoryId)
    },
    displayBidCard: function () {
      if (this.currentLiveInventoryId === null) {
        return ''
      }

      if (this.itemBiddingStatus.current_high_bidcard === 1000001) {
        return 'FLOOR'
      }

      if (this.itemBiddingStatus.current_high_bidcard === 1000002) {
        return 'PHONE'
      }

      if (this.itemBiddingStatus.current_high_bidcard === 1000003) {
        return 'INV'
      }

      if (this.itemBiddingStatus.current_high_bidcard === 1000005) {
        return 'LA'
      }

      return '#' + this.itemBiddingStatus.current_high_bidcard
    },

    customerMaxBid: function () {
      return this.$store.getters.customerMaxBid(this.item_id)
    },

    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated
    },

    Podium: function () {
      return this.$store.getters.podium
    },

    currentAsking: function () {
      return this.$store.getters.podium.current.asking
    },
    auctionStatus: function () {
      return this.$store.getters.auctionStatus(this.item_id)
    },
    currentAuctionId: function () {
      return this.$store.getters.itemBiddingStatus(this.currentLiveInventoryId).auction_id
    }
  },
  watch: {
    currentAsking: function () {
      this.setAskingAmount(this.itemBiddingStatus.current_asking_bid)
    },
    currentAuctionId: function () {
      this.setCurrentAuctionId(this.itemBiddingStatus.auction_id)
    },
    itemBiddingStatus: function () {
      this.setAskingAmount(this.itemBiddingStatus.current_asking_bid)
      if (this.itemBiddingStatus.auction_id) {
        this.setCurrentAuctionId(this.itemBiddingStatus.auction_id)
      }
    },
    apiResponse: function () {
      const response = this.$store.getters.apiResponse.place_bid
      const exists = this.messageList.filter(item => {
        return item === response
      })
      if (response && exists.length === 0) {
        this.messageList.unshift(response)
      }
      if (this.messageList.length > 100) {
        this.messageList.length = 100
      }
    }
  },
  mounted () {
  },

  methods: {
    formatCurrency: function (amount) {
      if (amount !== null) {
        return (amount).toString().replace(/\d(?=(\d{3})+$)/g, '$&,')
      }
      return ''
    },
    setCurrentAuctionId: function (auctionId) {
      this.setAuctionId = auctionId
    },
    setAskingAmount: function (amount) {
      // if there is no bid waiting for us to evaluate, we can advance the current ask to the latest from pusher
      // determined the same way that the green button state is determined
      if (this.Podium.upNow.amount !== null && !this.itemBiddingStatus.pending_bid) {
        this.askingAmount = this.Podium.upNow.amount

      // otherwise, there is a pending bid (the button is green, so the asking about should always be the same as what is in the green button (if there is one)
      } else {
        this.askingAmount = amount
      }
    },
    recognizeBid () {
      const payload = {
        'inventory_id': this.item.inventory_id,
        'bid_id': this.Podium.upNow.id
      }

      this.askingAmount = this.$store.getters.podium.current.asking
      this.$store.dispatch('recognizeBid', payload)
    },
    floorBid () {
      let finalAskingAmount = this.askingAmount
      if (this.customBidAmount > 0) {
        finalAskingAmount = this.customBidAmount
        this.customBidAmount = ''
      }

      const payload = {
        'bid_amount': finalAskingAmount,
        'inventory_id': this.item.inventory_id,
        'confirmed': true,
        'assume_customer': 'FLOOR'
      }
      this.$store.dispatch('placeBid', payload).then(() => {
        // After the bid has been placed, update the askingAmount
        this.askingAmount = this.$store.getters.podium.current.asking
      })
    },
    phoneBid () {
      let finalAskingAmount = this.askingAmount
      if (this.customBidAmount > 0) {
        finalAskingAmount = this.customBidAmount
        this.customBidAmount = ''
      }
      const payload = {
        'bid_amount': finalAskingAmount,
        'inventory_id': this.item.inventory_id,
        'confirmed': true,
        'assume_customer': 'PHONE'
      }
      this.$store.dispatch('placeBid', payload).then(() => {
        // After the bid has been placed, update the askingAmount
        this.askingAmount = this.$store.getters.podium.current.asking
      })
    },
    houseBid () {
      let finalAskingAmount = this.askingAmount
      if (this.customBidAmount > 0) {
        finalAskingAmount = this.customBidAmount
        this.customBidAmount = ''
      }

      const payload = {
        'bid_amount': finalAskingAmount,
        'inventory_id': this.item.inventory_id,
        'confirmed': true,
        'assume_customer': 'HOUSE'
      }
      this.$store.dispatch('placeBid', payload).then(() => {
        // After the bid has been placed, update the askingAmount
        this.askingAmount = this.$store.getters.podium.current.asking
      })
    },
    laBid () {
      const payload = {
        'bid_amount': this.askingAmount,
        'inventory_id': this.item.inventory_id,
        'confirmed': true,
        'assume_customer': 'LIVEAUCTIONEERS'
      }
      this.$store.dispatch('placeBid', payload)
    },
    setLot () {
      const setLotPayload = {
        'lot_number': this.setLotNumber,
        'auction_id': this.setAuctionId
      }
      this.$store.dispatch('setLot', setLotPayload)

      const startVirtualAuctioneerPayload = {
        'auction_id': this.setAuctionId,
        'live_auctioneers_url': this.liveAuctioneersUrl
      }
      this.$store.dispatch('startVirtualAuctioneer', startVirtualAuctioneerPayload)
    },
    startAuction () {
      const payload = {
        'auction_id': this.setAuctionId,
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('startAuction', payload)
    },
    endAuction () {
      const payload = {
        'auction_id': this.setAuctionId,
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('endAuction', payload)
    },
    pauseAuction () {
      const payload = {
        'auction_id': this.setAuctionId,
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('pauseAuction', payload)
    },
    resumeAuction () {
      const payload = {
        'auction_id': this.setAuctionId,
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('resumeAuction', payload)
    },
    nextLot () {
      const payload = {
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('nextLot', payload)
      // this.messageList.length = 0;
    },
    sendPodiumMessage () {
      const payload = {
        'message': this.customMessage,
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('sendPodiumMessage', payload)
    },
    sendSellingNowMessage () {
      const payload = {
        'message': 'Please bid quickly!',
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('sendPodiumMessage', payload)
    },
    sendFairWarningMessage () {
      const payload = {
        'message': 'Fair warning!',
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('sendPodiumMessage', payload)
    },
    sendFinalCallMessage () {
      const payload = {
        'message': 'Final call! I\'m selling!',
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('sendPodiumMessage', payload)
    },
    closeBidding () {
      const payload = {
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('closeBidding', payload)
    },
    openBidding () {
      const payload = {
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('openBidding', payload)
    },
    sellLot () {
      const payload = {
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('sellLot', payload)
    },
    passLot () {
      let willPass = window.confirm('Are you sure you want to pass?')
      if (!willPass) {
        return
      }
      const payload = {
        'inventory_id': this.item.inventory_id
      }
      this.$store.dispatch('passLot', payload)
    }
  }
}
</script>

<style scoped>
</style>
